import commonGetters from '@/store/data/common/getters'
import { find, toNumber } from 'lodash'

const getters = {
    ...commonGetters,
    getAccountsDspById: state => params => {
        return find(state.list, accountsDsp => toNumber(accountsDsp.id) === toNumber(params.id)) || null
    }
}

export default getters
